import JDatatableP6 from './JDatatableP6'
export { JDatatableP6 }
export default JDatatableP6